(function (angular) {
  "use strict";

  angular.module("app").service("Pages", pages);

  pages.$inject = ["modalService", "PagesApi"];

  function pages(modalService, PagesApi) {
    /**
     * Opens a modal allowing a user to create an page
     * @return {object} - modalService containing result.then
     */
    function createPage() {
      return modalService.open({
        templateUrl: "modals/manage-page.html",
        controller: "managePageController",
        windowClass: "manage-page",
        resolve: {
          pageId: function () {
            return null;
          },
        },
      });
    }

    /**
     * Opens a modal allowing a user to edit a page
     * @param  {int} pageId - ID of page
     * @return {object} - modalService containing result.then
     */
    function editPage(pageId) {
      if (!pageId) {
        return false;
      }

      return modalService.open({
        templateUrl: "modals/manage-page.html",
        controller: "managePageController",
        windowClass: "manage-page",
        resolve: {
          pageId: function () {
            return pageId;
          },
        },
      });
    }

    return {
      create: createPage,
      edit: editPage,
    };
  }
})(angular);
